module.exports = __webpack_public_path__ + "static/media/Archivo-SemiBold.61e00564.ttf";